import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import config from '../../../core/config/configureSettings';
import {getRoles} from '../../user/redux/selectors/UserReportSelectors';

// eslint-disable-next-line react/prefer-stateless-function
class ApplicationsContainer extends Component {
  render() {
    const amtUsers = ['USER_ROLE_AMT_MANAGER', 'USER_ROLE_AMT_BAG_USER', 'USER_ROLE_AMT_TRAY_USER', 'USER_ROLE_AMT_PALLET_BOX_USER'];
    let checkedAmtApp;
    if (this.props.roles !== undefined) {
      checkedAmtApp = this.props.roles.some(v => amtUsers.indexOf(v) !== -1);
    }
    return (
      <div className="dashboard-content">
        <div className="app-tile-container">
          <a href={config.applications.assetManagement} target="_blank" className={`link-div-${checkedAmtApp}`}>
            <div className={`tile-div-${checkedAmtApp}`}>
              <h5 className="tile-title">Asset Management</h5>
            </div>
          </a>
          <a href={config.applications.paperfree} target="_blank" className="link-div-true">
            <div className="tile-div-true">
              <h5 className="tile-title">Paperfree</h5>
            </div>
          </a>
        </div>
      </div>
    );
  }
}

ApplicationsContainer.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = state => ({
  roles: getRoles(state),
});

export default connect(mapStateToProps)(ApplicationsContainer);
